import React from 'react';
import { Typography } from '@material-ui/core';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer style={{ 
      backgroundColor: '#f5f5f5',
      padding: '1rem',
      textAlign: 'center',
      left: 0,
      bottom: 0,
    }}>
      <Typography variant="body2" color="textSecondary">
        © {year} INTERNATIONAL APPAREL & TEXTILE FAIR, DUBAI, UAE. ALL RIGHTS RESERVED
      </Typography>
    </footer>
  );
};

export default Footer;
